import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Cookie, X } from 'lucide-react';

const STORAGE_KEY = 'mtripcare_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem(STORAGE_KEY, 'refused');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Consentement cookies"
    >
      <div className="max-w-4xl mx-auto bg-[#0F394C] text-white rounded-2xl shadow-2xl p-5 md:p-6">
        <div className="flex flex-col md:flex-row md:items-center gap-4">
          <div className="flex items-start gap-3 flex-1">
            <div className="w-9 h-9 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0 mt-0.5">
              <Cookie className="w-4 h-4 text-white" />
            </div>
            <div>
              <p className="font-semibold text-sm text-white mb-1">
                Respect de votre vie privée
              </p>
              <p className="text-xs text-white/70 leading-relaxed">
                Nous utilisons des cookies essentiels pour le bon fonctionnement du site. 
                Avec votre accord, nous utilisons également des cookies d'analyse pour améliorer nos services.{' '}
                <Link to="/cookies" className="underline hover:text-white/90 transition-colors" data-testid="cookie-policy-link">
                  En savoir plus
                </Link>
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <Button
              variant="ghost"
              size="sm"
              onClick={refuse}
              className="text-white/70 hover:text-white hover:bg-white/10 rounded-full text-xs h-9 px-4"
              data-testid="cookie-refuse-btn"
            >
              Refuser
            </Button>
            <Button
              size="sm"
              onClick={accept}
              className="bg-[#E07A5F] hover:bg-[#c96a50] text-white rounded-full text-xs h-9 px-5 font-semibold"
              data-testid="cookie-accept-btn"
            >
              Accepter
            </Button>
            <button
              onClick={refuse}
              className="text-white/40 hover:text-white/80 transition-colors ml-1"
              aria-label="Fermer"
              data-testid="cookie-close-btn"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
